export default "__VITE_ASSET__CUlcV5NX__"